import React, { useEffect } from "react";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl md:text-2xl font-semibold text-white">{title}</h2>
    <div className="space-y-3 text-sm md:text-base leading-7 text-white/75">{children}</div>
  </section>
);

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Política de privacidad | Las Dos Doncellas";
  }, []);

  return (
    <main className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-4xl px-6 py-12 md:py-16">
        <header className="border-b border-white/10 pb-8">
          <p className="text-sm uppercase tracking-[0.22em] text-[#D6EF4E]">Las Dos Doncellas</p>
          <h1 className="mt-3 text-3xl md:text-5xl font-semibold">Política de privacidad</h1>
          <p className="mt-4 max-w-3xl text-white/65 leading-7">
            Información sobre el tratamiento de datos personales en nuestros canales de atención,
            comunicación y gestión comercial.
          </p>
          <p className="mt-3 text-sm text-white/45">Última actualización: 19 de septiembre de 2026</p>
        </header>

        <div className="mt-10 space-y-10">
          <Section title="1. Responsable del tratamiento">
            <p>
              El responsable del tratamiento es Alberto González Ortiz, con NIF 77815813M, titular de
              Las Dos Doncellas Tienda Ibéricos, con domicilio en Plaza Amarilla 3, 41230 Castilblanco
              de los Arroyos, Sevilla, España.
            </p>
            <p>
              Para cuestiones relacionadas con privacidad o para ejercer derechos sobre datos
              personales, puede contactar en lasdosdoncellas.ibericos@gmail.com.
            </p>
          </Section>

          <Section title="2. Datos que podemos tratar">
            <p>
              Podemos tratar datos identificativos y de contacto facilitados por el propio usuario,
              como nombre, teléfono, correo electrónico, nombre de usuario o identificadores técnicos
              asociados al canal utilizado. También podemos tratar el contenido de las conversaciones,
              consultas, solicitudes, pedidos, incidencias y archivos que el usuario decida enviar.
            </p>
            <p>
              Cuando la comunicación se realiza mediante WhatsApp, Facebook Messenger, Instagram u
              otros servicios de terceros, podemos recibir los datos que dichas plataformas ponen a
              disposición de la empresa de acuerdo con sus propias condiciones y la configuración del
              usuario.
            </p>
          </Section>

          <Section title="3. Finalidades">
            <p>
              Los datos se utilizan para atender consultas, gestionar conversaciones y solicitudes,
              preparar y tramitar pedidos o servicios, prestar atención al cliente, gestionar
              incidencias, mantener el historial comercial necesario y mejorar la organización de la
              relación con nuestros clientes.
            </p>
            <p>
              Cuando exista una base jurídica válida, también podremos enviar comunicaciones
              comerciales relacionadas con productos, novedades o promociones. El usuario podrá
              oponerse o retirar su consentimiento cuando corresponda.
            </p>
          </Section>

          <Section title="4. Canales digitales y CRM">
            <p>
              Las Dos Doncellas puede centralizar en su sistema interno de gestión comercial (CRM/ERP)
              las conversaciones recibidas desde WhatsApp, Facebook Messenger, Instagram, correo
              electrónico y otros canales habilitados. Esta centralización permite identificar el
              canal de origen, dar continuidad a la atención y evitar que una misma solicitud tenga
              que ser gestionada de forma aislada en cada plataforma.
            </p>
            <p>
              Determinadas tareas de clasificación, preparación de respuestas o extracción de
              información pueden contar con sistemas automatizados o de inteligencia artificial como
              apoyo operativo. Se aplican controles para que las conversaciones puedan ser asumidas
              por personal autorizado cuando sea necesario.
            </p>
          </Section>

          <Section title="5. Base jurídica">
            <p>
              El tratamiento puede basarse, según el caso, en la ejecución de medidas solicitadas por
              el usuario o de una relación contractual, en el cumplimiento de obligaciones legales,
              en el interés legítimo para gestionar adecuadamente la relación y seguridad del servicio,
              o en el consentimiento cuando este sea necesario, especialmente para determinadas
              comunicaciones comerciales.
            </p>
          </Section>

          <Section title="6. Destinatarios y proveedores">
            <p>
              Los datos no se venden. Podrán ser tratados por proveedores tecnológicos que prestan
              servicios necesarios para comunicaciones, alojamiento, bases de datos, correo,
              automatización o gestión empresarial, bajo las condiciones y garantías aplicables.
            </p>
            <p>
              El uso de servicios de Meta, incluido WhatsApp, Facebook e Instagram, implica asimismo
              el tratamiento de información por las entidades de Meta que correspondan conforme a sus
              propias políticas y condiciones.
            </p>
          </Section>

          <Section title="7. Transferencias internacionales">
            <p>
              Algunos proveedores tecnológicos pueden tratar información fuera del Espacio Económico
              Europeo. Cuando resulte aplicable, se utilizarán los mecanismos y garantías previstos
              por la normativa de protección de datos para dichas transferencias.
            </p>
          </Section>

          <Section title="8. Conservación">
            <p>
              Los datos se conservarán durante el tiempo necesario para atender la finalidad para la
              que fueron recogidos, mantener la relación comercial y cumplir las obligaciones legales
              aplicables. Cuando dejen de ser necesarios, se eliminarán o bloquearán según corresponda.
            </p>
          </Section>

          <Section title="9. Derechos de las personas">
            <p>
              Las personas interesadas pueden solicitar, cuando proceda, el acceso, rectificación,
              supresión, oposición, limitación del tratamiento y portabilidad de sus datos, así como
              retirar el consentimiento sin afectar a la licitud del tratamiento previo.
            </p>
            <p>
              También pueden presentar una reclamación ante la Agencia Española de Protección de Datos
              si consideran que el tratamiento de sus datos personales no se ajusta a la normativa.
            </p>
          </Section>

          <Section title="10. Seguridad">
            <p>
              Aplicamos medidas técnicas y organizativas orientadas a proteger los datos personales y
              limitar el acceso a la información a usuarios y sistemas autorizados, teniendo en cuenta
              la naturaleza de los datos y los servicios utilizados.
            </p>
          </Section>

          <Section title="11. Cambios en esta política">
            <p>
              Esta política podrá actualizarse para reflejar cambios legales, técnicos o en los canales
              y servicios utilizados. La versión vigente estará disponible públicamente en esta misma
              dirección.
            </p>
          </Section>
        </div>

        <footer className="mt-14 border-t border-white/10 pt-6 text-sm text-white/45">
          © 2026 Las Dos Doncellas Tienda Ibéricos
        </footer>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
